import React from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useResponsiveness } from '@monorepo/react-hooks';
import { formatDate } from '@monorepo/client-common';
import { Icons } from '@monorepo/icons';
import { IconsNames } from '@monorepo/types';
import { NOT_AVAILABLE } from '@monorepo/types';
import { TextComponent, Flex, Avatar } from '../../../ui-kit';

import styles from './author-info.module.scss';

dayjs.extend(relativeTime);

type AuthorInfoProps = {
  userImg?: string;
  author?: string;
  createdAt?: string;
  customDate?: string;
  onAuthorInfoClick?: VoidFunction;
  renderDateSuffix?: React.ReactNode;
};

export const AuthorInfo = ({
  userImg,
  author = NOT_AVAILABLE,
  createdAt,
  customDate,
  onAuthorInfoClick,
  renderDateSuffix = null,
}: AuthorInfoProps) => {
  const { isMobile } = useResponsiveness();

  const renderDate = () => {
    if (customDate) {
      return customDate;
    }

    if (!createdAt) {
      return null;
    }

    const createdAtDayjs = dayjs(createdAt);
    const diffHours = dayjs().diff(createdAtDayjs, 'hour');

    return diffHours >= 24
      ? formatDate(createdAt, { template: 'mediumThin' })
      : dayjs().to(createdAtDayjs);
  };

  return (
    <Flex gap={8} align="center" className={styles['userInfo']}>
      <div className={styles['avatar']}>
        {userImg ? (
          <Avatar
            onClick={onAuthorInfoClick}
            src={userImg}
            className={classNames({
              [styles['clickable']]: !!onAuthorInfoClick,
            })}
          />
        ) : (
          <Icons
            onClick={onAuthorInfoClick}
            iconName={IconsNames.People}
            className={classNames(styles['noAvatar'], {
              [styles['clickable']]: !!onAuthorInfoClick,
            })}
          />
        )}
      </div>
      <Flex vertical>
        <TextComponent
          onClick={onAuthorInfoClick}
          level={isMobile ? 6 : 7}
          className={classNames(styles['author'], {
            [styles['clickable']]: !!onAuthorInfoClick,
          })}
        >
          {author}
        </TextComponent>
        <TextComponent level={8} className={styles['date']}>
          {renderDate()}
          {renderDateSuffix}
        </TextComponent>
      </Flex>
    </Flex>
  );
};
